import { a as e, i as t, n, r, t as i } from "./SkeletonMapReader-ZPwsqemZ.js";
//#region src/bigmap/buildSkeleton.ts
var a = (e) => !!e && Object.keys(e).length > 0;
function o(e) {
	return !!e.roomChar || a(e.customLines) || a(e.specialExits) || (e.stubs?.length ?? 0) > 0 || a(e.doors) || (e.exitLocks?.length ?? 0) > 0;
}
function s(t, n = [], r = {}) {
	let i = r.isDetailRoom ?? o, s = 0;
	for (let e of t) s += e.rooms.length;
	let c = new Int32Array(s), l = new Int32Array(s), u = new Int32Array(s), d = new Int32Array(s), f = new Int32Array(s), p = new Int32Array(s), m = new Int32Array(s * 12).fill(-1), h = Array(s), g = [], _ = [], v = [], y = {}, b = {}, x = 0;
	for (let n of t) {
		let t = parseInt(n.areaId);
		y[t] = n.areaName;
		for (let e of n.labels ?? []) v.push({
			...e,
			areaId: e.areaId ?? t
		});
		for (let t of n.rooms) {
			c[x] = t.x, l[x] = t.y, u[x] = t.z, d[x] = t.area, f[x] = t.env, p[x] = t.id;
			let n = x * 12;
			for (let r = 0; r < 12; r++) {
				let i = t.exits?.[e[r]];
				i !== void 0 && (m[n + r] = i);
			}
			h[x] = t.name ?? "", a(t.userData) && g.push({
				id: t.id,
				data: t.userData
			}), t.hash && (b[t.hash] = t.id), i(t) && _.push({ ...t }), x++;
		}
	}
	let S = {};
	for (let e of n) S[e.envId] = {
		r: e.colors[0],
		g: e.colors[1],
		b: e.colors[2]
	};
	let C = {};
	for (let e of r.gridAreas ?? []) C[e] = !0;
	return {
		count: s,
		x: c,
		y: l,
		z: u,
		area: d,
		env: f,
		id: p,
		exits: m,
		areaNames: y,
		areaGridMode: C,
		customEnvColors: S,
		names: h,
		userData: g,
		detailRooms: _,
		labels: v,
		hashToId: b
	};
}
//#endregion
export { e as SKELETON_DIRS, i as SkeletonMapReader, n as buildPlaneIndex, s as buildSkeleton, r as countInBounds, t as forEachInBounds, o as hasVisualDetail };

//# sourceMappingURL=bigmap.mjs.map